import PropTypes from 'prop-types';
import { Box, Pagination, Typography } from '@mui/material';
import ResourceCard from '../../components/ResourceCard';
import ProductCard from '../../components/ProductCard';
import useDetailsDrawer from '../../hooks/useDetailsDrawer';
import DetailsDrawer from '../../components/DetailsDrawer';
import { router } from '@inertiajs/react';
import NoResults from '../../components/NoResults';

function SearchList({ items, pagination }) {
  const {
    isOpen: isResourceDrawerOpen,
    onOpen: onOpenResourceDrawer,
    onClose: onCloseResourceDrawer,
    detailItem: resource,
  } = useDetailsDrawer('resource', 'resource_id');

  const {
    isOpen: isProductDrawerOpen,
    onOpen: onOpenProductDrawer,
    onClose: onCloseProductDrawer,
    detailItem: product,
  } = useDetailsDrawer();

  const { page, pages, scaffold_url: scaffoldUrl } = pagination;

  const handleNewPage = (page) => {
    const newPageUrl = scaffoldUrl.replace('__pagy_page__', page);
    router.visit(newPageUrl, {
      preserveScroll: false,
      preserveState: true,
    });
  };

  if (items.length === 0) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center">
        <Typography variant="h3" textAlign="center" mb={3}>
          Sorry, we couldn&apos;t find any results that match your search.
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Box display="flex" flexDirection="column">
        {items.map((item) => (
          <Box key={item.id} mb={2}>
            {item.class === 'resource' ? (
              <ResourceCard resource={item} onClick={onOpenResourceDrawer(item.id)} />
            ) : item.class === 'product' ? (
              <ProductCard product={item} onClick={onOpenProductDrawer(item.id)} />
            ) : null}
          </Box>
        ))}

        <Box display="flex" justifyContent="center" mt={2}>
          <Pagination
            page={page}
            count={pages}
            onChange={(_, num) => handleNewPage(num)}
            color="primary"
            sx={{
              '& .MuiPaginationItem-root': {
                '&:hover, &:focus-visible': {
                  backgroundColor: 'gray.450',
                  color: 'common.white',
                },
              },
            }}
          />
        </Box>
      </Box>

      <DetailsDrawer
        isOpen={isResourceDrawerOpen}
        onClose={onCloseResourceDrawer}
        detailItem={resource}
        isProduct={false}
        onShowProduct={onOpenProductDrawer}
      />

      <DetailsDrawer
        isOpen={isProductDrawerOpen}
        onClose={onCloseProductDrawer}
        detailItem={product}
        onShowResource={onOpenResourceDrawer}
      />
    </>
  );
}

SearchList.propTypes = {
  items: PropTypes.array,
  pagination: PropTypes.shape({
    page: PropTypes.number,
    pages: PropTypes.number,
    next: PropTypes.number,
    scaffold_url: PropTypes.string,
  }),
};

export default SearchList;
